import { Helmet } from "react-helmet-async";
import { styled } from "@mui/material/styles";
import { Container, Typography } from "@mui/material";
import useResponsive from "../../../hooks/use-responsive";
import Logo from "../../../components/logo";
import { ForgotPassword } from "../../../sections/auth/forgot-password";
import palette from "../../../theme/palette";

const StyledRoot = styled("div")(({ theme }) => ({
  [theme.breakpoints.up("md")]: {
    display: "flex",
  },
}));

const StyledSection = styled("div")(({ theme }: any) => ({
  width: "100%",
  maxWidth: 480,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  boxShadow: theme.customShadows.card,
  backgroundColor: theme.palette.background.default,
}));

const StyledContent = styled("div")(({ theme }) => ({
  maxWidth: 480,
  margin: "auto",
  minHeight: "100vh",
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  padding: theme.spacing(12, 0),
}));

const Footer = styled("div")(({ theme }) => ({
  flexShrink: 0,
  backgroundColor: palette.grey[300],
  padding: 15,
  marginTop: "auto",
  bottom: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

export default function ForgotPasswordPage() {
  const mdUp = useResponsive("up", "md", "");
  let year = new Date().getFullYear();
  return (
    <>
      <Helmet>
        <title> Forgot Password | EventPrix </title>
      </Helmet>

      <StyledRoot>
        <Logo
          sx={{
            position: "fixed",
            top: { xs: 16, sm: 24, md: 40 },
            left: { xs: 16, sm: 24, md: 40 },
          }}
        />

        {mdUp && (
          <StyledSection>
            <Typography variant="h3" sx={{ px: 5, mt: 10, mb: 5 }}>
              Hi, Welcome Back
            </Typography>
            <img
              src="/assets/illustrations/illustration_login.png"
              alt="login"
            />
          </StyledSection>
        )}
        <div style={{ paddingLeft: 0, paddingRight: 0, width: "100%" }}>
          <Container maxWidth="sm">
            <StyledContent>
              <Typography variant="h4" gutterBottom>
                Forgot Password
              </Typography>

              <ForgotPassword />
            </StyledContent>
          </Container>
          <Footer>
            <Typography>
              Copyright© {year} EventPrix LLC. All Rights Reserved.
            </Typography>
          </Footer>
        </div>
      </StyledRoot>
    </>
  );
}
